export default "__VITE_ASSET__8RwPDQA1__"